import React from 'react';
import { AppBar, Toolbar, IconButton, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../actions/authActions';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  
  const handleLogout = () => {
    dispatch(logout());
  };

  let homeRoute = '/';
  if (auth.isAuthenticated && auth.user) {
    // Adjust these role values as needed.
    if (auth.user.role_name === 'admin') {
      homeRoute = '/admin';
    } else if (auth.user.role_name === 'teacher') {
      homeRoute = '/teacher';
    } else {
      homeRoute = '/';
    }
  }

  return (
    <AppBar position="static">
      <Toolbar>
        <IconButton edge="start" color="inherit" aria-label="home" component={Link} to={homeRoute}>
          <img 
            src="/margot.jpg" 
            alt="Home Icon" 
            style={{ width: 40, height: 40, borderRadius: '50%' }} 
          />
        </IconButton>
        <div style={{ marginLeft: 'auto' }}>
          {auth.isAuthenticated ? (
            <>
              <Button color="inherit" component={Link} to={homeRoute}>
                Acasă
              </Button>
              <Button color="inherit" component={Link} to="/attendance">
                Raport de prezență
              </Button>
              <Button color="inherit" onClick={handleLogout}>
                Deconectare
              </Button>
            </>
          ) : (
            <Button color="inherit" component={Link} to="/login">
              Autentificare
            </Button>
          )}
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
